import React from 'react';
import classNames from 'classnames';
import Icon from '../../design-system/icon.jsx';

export const Quantity = ({
  amount,
  className,
  onIncreaseQuantity,
  onDecreaseQuantity
}) => (
  <div className={classNames('quantity-toggle__container noselect', className)}>
      <span className='quantity-toggle__button' onClick={onDecreaseQuantity}>
        <Icon type="minus" />
      </span>
    <input
      type="number"
      id="quantity"
      name="quantity"
      value={amount}
      min="0"
      className="quantity-toggle__amount"
      readOnly
    />
    <span className='quantity-toggle__button' onClick={onIncreaseQuantity}>
        <Icon type="plus" />
     </span>
  </div>
);
